import { useState } from 'react';
import LogoutConfirmationPopUp from './LogoutConfirmationPopUp';

const LogoutButton = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="px-4 py-2 text-sm text-red-600 bg-red-100 rounded-md hover:bg-red-200 transition-colors whitespace-nowrap"
      >
        Se déconnecter
      </button>

      {open && <LogoutConfirmationPopUp onClose={() => setOpen(false)} />}
    </>
  );
};

export default LogoutButton;
